import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { formStates } from './';
import { ResetPasswordLayout } from '../../layouts/ResetPassword/ResetPassword';
import ResetPasswordForm from './components/reset-password-form/ResetPasswordForm';
import ResetPasswordSuccessScreen from './components/reset-password-success-screen/ResetPasswordSuccessScreen';
import { resetPassword } from '../../api/actions';
import { DocumentTitle } from '../../components/DocumentTitle';

export class ResetPassword extends Component {
  static propTypes = {
    invalidResetPasswordToken: PropTypes.bool.isRequired,
    resetPassword: PropTypes.func.isRequired,
  };

  state = {
    email: '',
    errors: {
      email: '',
      invalidResetPasswordToken: false,
      resetPassword: '',
    },
    formState: formStates.INITIAL,
  };

  render() {
    return (
      <DocumentTitle title={'SolarWinds Cloud'}>
        <ResetPasswordLayout>{this.renderContent()}</ResetPasswordLayout>
      </DocumentTitle>
    );
  }

  renderContent = () => {
    if (this.isFormInSuccessState()) {
      return this.renderResetPasswordSuccessContent();
    } else {
      return this.renderResetPasswordForm();
    }
  };

  renderResetPasswordSuccessContent() {
    return <ResetPasswordSuccessScreen email={this.state.email} />;
  }

  renderResetPasswordForm() {
    return (
      <ResetPasswordForm
        isLoading={this.isFormInLoadingState()}
        email={this.state.email}
        errors={this.getErrors()}
        handleSubmit={this.handleSubmit}
        handleChangeEmail={this.handleChangeEmail}
        handleEmailError={this.handleEmailError}
      />
    );
  }

  isFormInSuccessState() {
    return this.state.formState === formStates.SUCCESS;
  }

  isFormInLoadingState() {
    return this.state.formState === formStates.LOADING;
  }

  handleSubmit = async () => {
    try {
      this.startLoading();
      await this.props.resetPassword(this.state.email);
      this.setFormSuccessState();
    } catch (error) {
      this.setErrors({ resetPassword: 'An unknown error occurred' });
      this.stopLoading();
    }
  };

  startLoading() {
    this.setState({ formState: formStates.LOADING });
  }

  stopLoading() {
    this.setState({ formState: formStates.INITIAL });
  }

  setFormSuccessState() {
    this.setState({ formState: formStates.SUCCESS });
  }

  setErrors(errors) {
    this.setState(prevState => ({
      errors: {
        ...prevState.errors,
        ...errors,
      },
    }));
  }

  handleEmailError = error => {
    this.setState(prevState => ({ errors: { ...prevState.errors, email: error } }));
  };

  handleChangeEmail = email => {
    this.setState(prevState => ({ email, errors: { ...prevState.errors, email: '' } }));
  };

  getErrors() {
    return {
      email: this.state.errors.email,
      invalidResetPasswordToken: this.props.invalidResetPasswordToken,
      resetPassword: this.state.errors.resetPassword,
    };
  }
}

const ResetPasswordWithInvalidResetPasswordToken = Component => props => {
  return <Component invalidResetPasswordToken={getInvalidResetPasswordToken()} resetPassword={resetPassword} />;

  function getInvalidResetPasswordToken() {
    return Boolean(props.location && props.location.state && props.location.state.invalidResetPasswordToken);
  }
};

export default ResetPasswordWithInvalidResetPasswordToken(ResetPassword);
